var _rect, _rect2, _rect3, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureViewMono(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.44,
    x: 2.83297,
    y: 16.833,
    width: 9.83405,
    height: 3.33405,
    fill: "#B6C5CF",
    stroke: "#B6C5CF",
    strokeWidth: 1.66595
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 2.83297,
    y: 9.83291,
    width: 18.3341,
    height: 3.33405,
    fill: "#B6C5CF",
    stroke: "#B6C5CF",
    strokeWidth: 1.66595
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 3.25,
    width: 17.5,
    height: 2.5,
    fill: "#B6C5CF",
    stroke: "#B6C5CF",
    strokeWidth: 2.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.8329,
    y1: 6.99994,
    x2: 12.8329,
    y2: 8.99994,
    stroke: "#B6C5CF",
    strokeWidth: 1.66595
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.08297,
    y1: 14,
    x2: 8.08297,
    y2: 16,
    stroke: "#B6C5CF",
    strokeWidth: 1.66595
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureViewMono);
export default __webpack_public_path__ + "static/media/feature-view-mono.e872849af889c35c3e64d5282a5ab7f2.svg";
export { ForwardRef as ReactComponent };